import React from 'react';
import { Animation } from '@catalogo/theme-animation';
import { Content, Hr, Exit } from './Styled';

const ModalSheet = ({ children, visible, exitFunc }: { children: any; visible: boolean; exitFunc?: () => void }) => (
  <Animation type="slide" direction="top" visible={visible} background={true} className="product-review-modal-sheet">
    <Content className="product-review-modal-sheet-content">
      <Exit onClick={exitFunc} className="product-review-modal-sheet-exit">
        <Hr className="product-review-modal-sheet-line" />
      </Exit>
      {children}
    </Content>
  </Animation>
);

export default ModalSheet;
export { ModalSheet };
